<ng-container *ngIf="widgets.length; else elseTemplate" >
    <ng-container *ngFor="let w of widgets" axf-widget-renderer [widget]="w" [parent]="this">
    </ng-container>
</ng-container>
<ng-template #elseTemplate>
    &nbsp;
</ng-template>